import {
  Box,
  styled,
  IconButton,
  InputAdornment,
  Grid,
  Button,
  Typography,
  FormHelperText as MuiFormHelperText,
  TextField,
  Dialog as MuiDialog,
} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useEffect, useRef, useState} from 'react';
import {mediaService} from '@jobseeker/common-core/services';
import Loader from '@jobseeker/lotus/components/Loader';
import {useFormik} from 'formik';
import {TrackEventUBA, getUbaPageName} from '@jobseeker/common-core/utils';
import {HiristBackground, PhoneIcon} from '@jobseeker/lotus/assets/images';
import {LockHirist, UnlockHirist} from '@jobseeker/lotus/assets/icons';
import {
  ChevronRight,
  CrossIcon,
  RightArrow,
  OrangeRightArrow,
} from '@jobseeker/lotus/assets/icons';
import {surveyService} from '@jobseeker/common-core/services';
import {
  validationSchemaLogin,
  validationSchemaForgot,
  validationSchemaSignUpHirist,
} from '../../../helpers/formValidator';
import {handleTracking} from '@jobseeker/common-core/utils';
import {login, register, forgotPassword} from '../../../helpers';
import {useDispatch, useSelector} from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import type {} from '@jobseeker/lotus/mui.types';
import {openUrl} from '@jobseeker/common-core/utils/common';
import FileUpload from '@jobseeker/lotus/components/FileUpload';
import DownloadAppOnJobdetail from '@jobseeker/lotus/components/DownloadAppJobdetailAndCatogary';
import {
  useIsCustomWidth,
  useValidateComponent,
} from '@jobseeker/lotus/hooks';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import {Tooltip} from '@jobseeker/lotus/elements';
import {useInterceptor, useLoadAds} from '@jobseeker/common-core';
import {getRefTagAndOrigin} from '@jobseeker/common-core/utils';
import {useRouter} from 'next/router';
import {VersionVariants} from '@jobseeker/lotus/enums';
import Dialog from '@jobseeker/lotus/components/Dialog';
import {getAllParamsFromUrl} from '@jobseeker/common-core/utils/common';
import Link from '@mui/material/Link';

const AuthLeft = styled(Box)(({theme}) => ({
  position: 'relative',
  height: '100vh',
  width: '100%',
  padding: '310px 0',
}));

const SiteLogo = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: 55,
  left: 70,
  '& img': {
    height: 40,
    filter: 'brightness(10)',
  },
}));
const CustomTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: '2px solid #e6e6e6',
    },
    '&:hover fieldset': {
      border: '2px solid #e6e6e6',
    },
    '&.Mui-focused fieldset': {
      border: '2px solid #e6e6e6',
    },
  },
  '& .MuiOutlinedInput-input': {
    paddingTop: '19px',
    paddingBottom: '19px',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
});

const PeopleSaying = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  textAlign: 'center',
  fontSize: 25,
  fontWeight: 800,
  lineHeight: 1.29,
  color: '#fff',
  padding: '0px 53px',
  '& p': {
    fontWeight: 'normal',
    lineHeight: 1.69,
    fontSize: 16,
  },
  [theme.breakpoints.down('lg')]: {
    padding: '0px 21px',
    position: 'relative',
    top: 'auto',
  },
}));
const FormHelperText = styled(MuiFormHelperText)(() => ({
  color: '#eb1c2a',
  marginTop: '-1px',
  fontSize: '14px',
  fontFamily: 'Nunito Sans',
}));

const CompanyList = styled(Box)(({theme}) => ({
  position: 'absolute',
  bottom: 30,
  width: '100%',
  '& p': {
    fontSize: 16,
    fontWeight: 'normal',
    color: '#fff',
    lineHeight: 1.69,
  },
  '& img': {
    margin: '0 10px',
    height: 40,
  },
}));

const HiristLoginForm = (props: any) => {
  const captchaRef = useRef<ReCAPTCHA>(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showSignUpPassword, setShowSignupPassword] = useState(false);
  const [showForgotSuccess, setShowForgotSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(false);
  const [openDialog, isOpenDialog] = useState(false);
  const [resumeFile, setResumeFile] = useState<string | Blob>();
  const metaData: any = useInterceptor();
  const router = useRouter();
  const allparamsfromurl = getAllParamsFromUrl() || {};
  const [openRegisterDialog, setOpenRegisterDialog] = useState(false);
  const params = new URLSearchParams(allparamsfromurl);
  const [handlePasswordRegexValidation, PasswordValidationComponent] =
    useValidateComponent(true);
  const handleFileUpload = async (formData: FormData) => {
    try {
      formData.append('mediaType', 'TextResume');
      const uploadInfo = await mediaService.uploadFile(formData);
      if (uploadInfo?.url) {
        setUploadedFile(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [apiError, setApiError] = useState<{
    message?: string;
    code?: number;
    activationToken?: string;
  }>({});

  const [isSignIn, setIsSignIn] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      reCaptchaCode: '',
    },
    validationSchema: validationSchemaLogin,
    onSubmit: async values => {
      setApiError({});
      setLoading(true);
      const {refText} = getRefTagAndOrigin();
      handleTracking('jsActionLogin', {
        event_category: 'jsHomePage',
        Source: 'login',
        Ref: `${refText}`,
        Device: sessionStorage.getItem('device') || 'desktop',
        Device_Type: sessionStorage.getItem('deviceType') || 'web',
      });
      handleUbaTracking('jsActionLoginClick', 'click');
      await handleAuthCall(values.email, values.password, values.reCaptchaCode);
    },
  });
  const formikSignUp = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: validationSchemaSignUpHirist,
    onSubmit: async values => {
      setApiError({});
      setLoading(true);
      const successfullregister = await handleRegisterCall(
        values.email?.trim(),
        values.password?.trim(),
        values.password?.trim(),
        true
      );
      const {refText} = getRefTagAndOrigin();
      handleTracking('jsActionRegister', {
        event_category: 'jsHomePage',
        Source: 'register',
        Ref: `${refText}`,
        Device: sessionStorage.getItem('device') || 'desktop',
        Device_Type: sessionStorage.getItem('deviceType') || 'web',
      });
      handleUbaTracking('jsActionRegisterClick', 'click', getUbaPageName());
      if (successfullregister) {
        props.onSuccessFulRegister && props.onSuccessFulRegister();
        if (resumeFile) {
          const formData = new FormData();
          formData.append('file', resumeFile);
          await handleFileUpload(formData);
          if ((allparamsfromurl.ref ?? '') !== 'google') {
            params.set('nu', '1');
          }
        }
        params.set('hir', '1');
        localStorage.removeItem('parsed-resume-content');
        params.set('source', 'reg');
        if ((allparamsfromurl.ref ?? '') !== 'google') {
          const parseresume = await surveyService.parseResume();
          localStorage.setItem(
            'parsed-resume-content',
            JSON.stringify(parseresume)
          );
        }
        const redirectToString = props?.customRedirectionUrl
          ? `&redirectto=${props?.customRedirectionUrl}`
          : '';

        openUrl(
          `/registration/addPersonalDetails?${params.toString()}${redirectToString}`,
          '_self'
        );
      }
      setLoading(false);
    },
    validateOnChange: true,
    validateOnBlur: true,
    validate: async values => {
      handlePasswordRegexValidation(values.password);
    },
  });
  const formikForgot = useFormik({
    initialValues: {
      email: '',
      reCaptchaCode: '',
    },
    validationSchema: validationSchemaForgot,
    onSubmit: async values => {
      setApiError({});
      setLoading(true);
      await handleForgotPassword(values.email?.trim(), values.reCaptchaCode);
      setLoading(false);
      formikForgot.setFieldValue('reCaptchaCode', '');
    },
  });
  let ref = '';
  if (window && window.location) {
    const urlParams = new URLSearchParams(window.location.search);
    ref = urlParams.get('ref') || '';
  }
  const [enableReCaptcha, setEnableReCaptcha] = useState(false);
  const [enableReCaptchaForgot, setEnableReCaptchaForgot] = useState(false);
  const dispatch = useDispatch();
  const handleReCAPTCHA = async (captchaCode: string | null) => {
    if (!captchaCode) {
      return;
    }

    formik.setFieldValue('reCaptchaCode', captchaCode);
    setApiError({});
  };
  const handleReCAPTCHAForgot = async (captchaCode: string | null) => {
    if (!captchaCode) {
      return;
    }

    formikForgot.setFieldValue('reCaptchaCode', captchaCode);
    setApiError({});
  };

  useEffect(() => {
    if (apiError && apiError.code && typeof apiError.code === 'number') {
      setLoading(false);
      if ([406].includes(apiError.code)) {
        if (isSignIn) {
          setEnableReCaptcha(true);
        } else if (isForgotPassword) {
          setEnableReCaptchaForgot(true);
        }
        if (apiError.code === 406) {
          captchaRef?.current?.reset();
        }
      }
    }
  }, [apiError, apiError?.code]);

  useEffect(() => {
    if (router.pathname === '/register') {
      setOpenRegisterDialog(true);
    } else {
      setOpenRegisterDialog(false);
    }
  }, [router.pathname]);

  useEffect(() => {
    if (apiError?.message) {
      setApiError({});
    }
    setEnableReCaptcha(false);
  }, [formik.values.email, formik.values.password]);

  useEffect(() => {
    if (apiError?.message) {
      setApiError({});
    }
  }, [formikSignUp.values.email, formikSignUp.values.password]);

  useEffect(() => {
    if (apiError?.message) {
      setApiError({});
    }
    setEnableReCaptchaForgot(false);
  }, [formikForgot.values.email]);

  const handleAuthCall = async (
    email: string,
    password: string,
    grecaptcha?: string
  ) => {
    try {
      setApiError({});
      const authInfo = await login(email, password, dispatch, grecaptcha);

      if (authInfo?.activationToken) {
        setLoading(false);
        setApiError({
          message: authInfo.message,
          code: 10999,
          activationToken: authInfo.activationToken,
        });
        return;
      }

      if (authInfo?.options?.reset) {
        setApiError({
          message: authInfo.message,
          code: 10203,
        });
        setLoading(false);
        return;
      }

      if (props.onSuccess && authInfo['token']) {
        props.onSuccess();
        return;
      }

      if (authInfo['token']) {
        if (window && window.location) {
          const urlParams = new URLSearchParams(window.location.search);
          const redirect = urlParams.get('redirectto');
          if (redirect) {
            openUrl(redirect, '_self');
            return;
          }
        }
        openUrl('/jobfeed', '_self');
      }

      setEnableReCaptcha(false);
    } catch (error) {
      if (typeof error === 'object' && error) {
        setApiError(error);
      }
      setLoading(false);
    }
    setEnableReCaptcha(false);
  };

  const handleRegisterCall = async (
    email: string,
    password: string,
    confirmPassword: string,
    policyCheck: boolean
  ) => {
    try {
      setLoading(true);
      const isregister = await register(
        email,
        password,
        confirmPassword,
        policyCheck,
        dispatch
      );
      // handleTracking('registered_user', {
      //   event_category: 'action',
      //   Label: 'SignUp User',
      //   Value: 'success',
      // });
      return isregister;
    } catch (error) {
      setLoading(false);
      if (typeof error === 'object' && error) {
        setApiError(error);
      }
    }
  };
  // const [showSignUpPassword, setShowSignupPassword] = useState(false);
  const [open, setOpen] = useState(false);

  const handleTooltipOpen = () => setOpen(true);
  const handleTooltipClose = () => setOpen(false);

  const handleForgotPassword = async (email: string, grecaptcha?: string) => {
    try {
      setLoading(true);
      const message = await forgotPassword(email, grecaptcha);
      if (message?.activationToken) {
        setLoading(false);
        setApiError({
          message: message.message,
          code: 10999,
          activationToken: message.activationToken,
        });
        return;
      }

      setShowForgotSuccess(true);
      setApiError({message, code: 0});
      // handleTracking('forgot_password_email_sent', {
      //   event_category: 'action',
      //   Label: 'Forgot Password',
      //   Value: 'success',
      // });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setShowForgotSuccess(false);
      if (typeof error === 'object' && error) {
        setApiError(error);
      }
    }
    setEnableReCaptchaForgot(false);
  };
  const handleDownloadClick = async () => {
    handleTracking('jsClickDwdAppBeforeLogin', {
      event_category: 'MobileAppPromotion',
      Origin: isSignIn ? 'SigninPage' : 'SignUpPage',
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
      Status: sessionStorage.getItem('status') || 'LoggedOut',
    });
    if (isSignIn) {
      openUrl('/downloadapp?ref=signin');
    } else openUrl('/downloadapp?ref=signup');
  };
  useEffect(() => {
    const {refText} = getRefTagAndOrigin();
    handleTracking('jsViewLoginLogo', {
      event_category: 'jsHomePage',
      Source: 'register',
      Ref: `${refText}`,
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
    });
    props?.enableSignIn && setIsSignIn(true);
  }, []);

  const handleUbaTracking = (
    eventName: any,
    action: any,
    page?: string,
    section?: string
  ) => {
    TrackEventUBA(eventName, action, {
      ...(page && {page}),
      ref: router.query.ref || '',
      ...(section && {section}),
      sessionUsername: sessionStorage.getItem('userId') || '',
    });
  };

  const handlebackclick = async () => {
    setForgotPassword(false);
    setApiError({});
    setEnableReCaptchaForgot(false);
    setIsSignIn(true);
  };

  const [isForgotPassword, setForgotPassword] = useState(false);
  const toggleAuthMode = () => {
    if (isSignIn) {
      setApiError({});
      setIsSignIn(false);
      handleUbaTracking('registrationInitialPageView', 'view');
      setForgotPassword(false);
    } else {
      handleUbaTracking('jsLoginLogoView', 'view', 'jsHomePage', 'signin');
      handleUbaTracking('loginPageView', 'view');
      setApiError({});
      setIsSignIn(true);
      setForgotPassword(false);
    }
  };
  const [companies, setCompanies] = useState<any>([]);
  const [ads, setAds] = useState<any>([]);
  useLoadAds(metaData.ads?.favouriteCompanies?.slot, setAds, {}, false);
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        if (ads && ads.length > 0) {
          setCompanies(ads);
        }
      } catch (error) {
        console.error('Error fetching companies:', error);
      }
    };

    fetchCompanies();
  }, [ads]);
  const renderForm = () => {
    if (isForgotPassword) {
      return (
        <Box
          component={'form'}
          noValidate
          onSubmit={event => {
            event.preventDefault();
            formikForgot.handleSubmit();
          }}
        >
          <Typography
            mb={'-10px'}
            fontWeight={700}
            color={'#000'}
            fontFamily={'Nunito Sans'}
            fontSize={'14px'}
            sx={{
              opacity: 0.8,
            }}
          >
            Email Address
          </Typography>
          <CustomTextField
            fullWidth
            type="email"
            margin="normal"
            placeholder="you@example.com"
            name="email"
            value={formikForgot.values.email}
            onChange={formikForgot.handleChange}
          />
          {formikForgot.touched.email && Boolean(formikForgot.errors.email) && (
            <FormHelperText>{formikForgot.errors.email}</FormHelperText>
          )}
          {enableReCaptchaForgot && (
            <Box display="flex" justifyContent="flex-start" mt={2}>
              <ReCAPTCHA
                ref={captchaRef}
                sitekey={`${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
                size="normal"
                onChange={handleReCAPTCHAForgot}
              />
            </Box>
          )}
          {apiError &&
            apiError.message !== '' &&
            apiError.message !== undefined && (
              <Typography
                component="p"
                fontSize="13px"
                color={'error.main'}
                display="inline-flex"
                flexDirection="column"
                textAlign="center"
                marginTop="10px"
              >
                {apiError.message}
                {apiError?.code === 10999 && (
                  <Box>
                    <Link
                      sx={{
                        textDecoration: 'underline',
                        textDecorationColor: '#e9630c',
                        '&:hover': {
                          textDecorationColor: '#e9630c',
                        },
                        textAlign: 'left',
                      }}
                      href={`reactivate-account${
                        apiError?.activationToken
                          ? `?em=${btoa(
                              formik.values.email
                            )}&token=${encodeURIComponent(
                              apiError?.activationToken
                            )}`
                          : ''
                      }`}
                    >
                      <Typography
                        sx={{
                          fontSize: '13px',
                          fontWeight: 500,
                          lineHeight: '16px',
                          color: 'primary.main',
                          marginTop: 0.5,
                        }}
                      >
                        Reactivate your account
                      </Typography>
                    </Link>
                  </Box>
                )}
              </Typography>
            )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            // disabled={loading}
            sx={{
              padding: '12px',
              fontSize: '20px',
              fontFamily: 'Nunito Sans',
              borderRadius: '8px',
              mt: 2,
              backgroundColor: '#e9630c',
              '&:hover': {
                backgroundColor: '#e9630c',
                boxShadow: '0px 6px 18px rgba(233, 99, 12, 0.19)',
              },
            }}
          >
            {loading ? (
              <Loader
                size={35}
                sx={{
                  color: '#ffffff !important',
                }}
              />
            ) : (
              'Reset Password'
            )}
          </Button>
        </Box>
      );
    }

    if (isSignIn) {
      return (
        <Box
          component={'form'}
          noValidate
          onSubmit={event => {
            event.preventDefault();
            formik.handleSubmit();
          }}
        >
          <Typography
            mb={'-10px'}
            fontWeight={700}
            color={'#000'}
            fontSize={'14px'}
            fontFamily={'Nunito Sans'}
            sx={{
              opacity: 0.8,
            }}
          >
            Email Address
          </Typography>
          <CustomTextField
            fullWidth
            type="email"
            margin="normal"
            placeholder="Enter your registered email id"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
          />
          {formik.touched.email && Boolean(formik.errors.email) && (
            <FormHelperText>{formik.errors.email}</FormHelperText>
          )}
          <Typography
            mt={{xxs: '15px', md: '25px'}}
            mb={'-10px'}
            fontWeight={700}
            color={'#000'}
            fontSize={'14px'}
            fontFamily={'Nunito Sans'}
            sx={{
              opacity: 0.8,
            }}
          >
            Password
          </Typography>
          <CustomTextField
            fullWidth
            type={showPassword ? 'text' : 'password'}
            margin="normal"
            placeholder="Enter your password"
            name="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(prev => !prev)}
                    edge="end"
                    aria-label="toggle password visibility"
                    disableRipple
                    disableFocusRipple
                    sx={{
                      backgroundColor: 'transparent',
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                      '&:focus': {
                        backgroundColor: 'transparent',
                      },
                      paddingRight: '15px',
                    }}
                  >
                    {showPassword ? (
                      <Image
                        src={UnlockHirist}
                        alt="unlock-icon"
                        height={16}
                        width={12}
                      />
                    ) : (
                      <Image
                        src={LockHirist}
                        alt="lock-icon"
                        height={16}
                        width={12}
                      />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {formik.touched.password && Boolean(formik.errors.password) && (
            <FormHelperText>{formik.errors.password}</FormHelperText>
          )}
          <Box sx={{textAlign: 'right'}}>
            <Typography
              component="a"
              sx={{
                textDecoration: 'none',
                cursor: 'pointer',
                display: 'inline-block',
                fontSize: openRegisterDialog ? '14px' : '16px',
                marginTop: openRegisterDialog ? '0px' : {xxs: '8px', md: '0px'},
                fontWeight: openRegisterDialog ? 700 : 400,
                color: '#0057ff',
                textAlign: 'right',
                fontFamily: 'Nunito Sans',
              }}
              onClick={() => {
                setApiError({});
                setForgotPassword(true);
                setEnableReCaptcha(false);
                setIsSignIn(false);
              }}
            >
              Forgot Password?
            </Typography>
          </Box>
          {enableReCaptcha && (
            <Box display="flex" justifyContent="flex-start" mt={2}>
              <ReCAPTCHA
                ref={captchaRef}
                sitekey={`${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
                size="normal"
                onChange={handleReCAPTCHA}
              />
            </Box>
          )}
          {apiError &&
            apiError.message !== '' &&
            apiError.message !== undefined && (
              <Typography
                component="p"
                fontSize="13px"
                color={'error.main'}
                display="inline-flex"
                flexDirection="column"
                textAlign="center"
                marginTop="10px"
              >
                {apiError.message}
                {apiError?.code === 10999 && (
                  <Box>
                    <Link
                      sx={{
                        textDecoration: 'underline',
                        textDecorationColor: '#e9630c',
                        '&:hover': {
                          textDecorationColor: '#e9630c',
                        },
                        textAlign: 'left',
                      }}
                      href={`reactivate-account${
                        apiError?.activationToken
                          ? `?em=${btoa(
                              formik.values.email
                            )}&token=${encodeURIComponent(
                              apiError?.activationToken
                            )}`
                          : ''
                      }`}
                    >
                      <Typography
                        sx={{
                          fontSize: '13px',
                          fontWeight: 500,
                          lineHeight: '16px',
                          color: 'primary.main',
                          marginTop: 0.5,
                        }}
                      >
                        Reactivate your account
                      </Typography>
                    </Link>
                  </Box>
                )}
              </Typography>
            )}

          <Button
            type="submit"
            fullWidth
            // disabled={loading}
            sx={{
              padding: '12px',
              backgroundColor: '#e9630c',
              fontSize: '20px',
              fontStyle: 'Nunito sans',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              mt: {xxs: '30px', md: 5.5},
              '&:hover': {
                backgroundColor: '#e9630c',
                boxShadow: '0px 6px 18px rgba(233, 99, 12, 0.19)',
              },
            }}
          >
            {loading ? (
              <Loader
                size={35}
                sx={{
                  color: '#ffffff !important',
                }}
              />
            ) : (
              <>
                Login
                <Image
                  src={RightArrow}
                  alt="right-arrow"
                  width={16}
                  height={16}
                  style={{
                    marginLeft: '6px',
                  }}
                />
              </>
            )}
          </Button>
        </Box>
      );
    }

    return (
      <Box
        component={'form'}
        noValidate
        onSubmit={event => {
          event.preventDefault();
          formikSignUp.handleSubmit();
        }}
      >
        <Typography
          mb={'-10px'}
          fontWeight={700}
          color={'#000'}
          fontSize={'14px'}
          sx={{
            opacity: 0.8,
          }}
        >
          Email Address
        </Typography>
        <CustomTextField
          fullWidth
          type="email"
          margin="normal"
          placeholder="you@example.com"
          name="email"
          value={formikSignUp.values.email}
          onChange={formikSignUp.handleChange}
        />
        {formikSignUp.touched.email && Boolean(formikSignUp.errors.email) && (
          <FormHelperText>{formikSignUp.errors.email}</FormHelperText>
        )}
        <Typography
          mt={{xxs: '15px', md: '20px'}}
          mb={'-10px'}
          fontWeight={700}
          color={'#000'}
          fontSize={'14px'}
          sx={{
            opacity: 0.8,
          }}
        >
          Password
        </Typography>
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <div>
            <Tooltip
              PopperProps={{disablePortal: true}}
              onClose={handleTooltipClose}
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={<PasswordValidationComponent />}
              arrow
              placement="top-start"
              sx={{
                '& .MuiTooltip-tooltip': {
                  backgroundColor: '#fafafa',
                  boxShadow: '0 1px 4px 0 hsla(0, 0%, 83.9%, 0.5)',
                  padding: '0px',
                },
              }}
            >
              <Box onClick={handleTooltipOpen}>
                <CustomTextField
                  fullWidth
                  type={showSignUpPassword ? 'text' : 'password'}
                  margin="normal"
                  placeholder="Enter 8 characters or more"
                  name="password"
                  value={formikSignUp.values.password}
                  onChange={formikSignUp.handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowSignupPassword(prev => !prev)}
                          edge="end"
                          aria-label="toggle password visibility"
                          disableRipple
                          disableFocusRipple
                          sx={{
                            backgroundColor: 'transparent',
                            '&:hover': {backgroundColor: 'transparent'},
                            '&:active': {backgroundColor: 'transparent'},
                            '&:focus': {backgroundColor: 'transparent'},
                            paddingRight: '15px',
                          }}
                        >
                          {showSignUpPassword ? (
                            <Image
                              src={UnlockHirist}
                              alt="unlock-icon"
                              height={16}
                              width={12}
                            />
                          ) : (
                            <Image
                              src={LockHirist}
                              alt="lock-icon"
                              height={16}
                              width={12}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Tooltip>
          </div>
        </ClickAwayListener>
        {formikSignUp.touched.password &&
          Boolean(formikSignUp.errors.password) && (
            <FormHelperText>{formikSignUp.errors.password}</FormHelperText>
          )}
        <Box mt={'22px'} mb={2}>
          <FileUpload
            Title={'Attach Resume'}
            SubTitle={
              'Use a PDF, doc, or docx file – make sure it’s 2MB or less'
            }
            SelectText={
              window.innerWidth <= 480
                ? 'Upload resume'
                : 'Upload or drag and drop'
            }
            FileSizeLimit={2}
            FileLimitError={
              'Resume needs to be less than 2 MB & should be in PDF, doc or docx format'
            }
            FileReceiver={file => {
              setResumeFile(file);
            }}
            resumeNameLimit={17}
          />
        </Box>
        {apiError &&
          apiError.message !== '' &&
          apiError.message !== undefined && (
            <Typography
              component="p"
              fontSize="13px"
              color={'error.main'}
              display="inline-flex"
              textAlign="center"
              marginTop="10px"
            >
              {apiError.message}
            </Typography>
          )}

        <Button
          type="submit"
          fullWidth
          variant="contained"
          // disabled={loading}
          sx={{
            padding: '12px',
            mt: 2,
            backgroundColor: '#e9630c',
            fontSize: '20px',
            fontStyle: 'Nunito Sans',
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: '#e9630c',
              boxShadow: '0px 6px 18px rgba(233, 99, 12, 0.19)',
            },
          }}
        >
          {loading ? (
            <Loader
              size={35}
              sx={{
                color: '#ffffff !important',
              }}
            />
          ) : openRegisterDialog ? (
            <>
              Register
              <Image
                src={RightArrow}
                alt="right-arrow"
                width={16}
                height={16}
                style={{
                  marginLeft: '6px',
                }}
              />
            </>
          ) : (
            'Continue'
          )}
        </Button>
      </Box>
    );
  };

  return openRegisterDialog ? (
    <Dialog
      open={openRegisterDialog}
      onClose={() => {
        setOpenRegisterDialog(false);
      }}
      variant={VersionVariants.VERSION_HIRIST_V1}
    >
      <Box
        // component={'form'}
        // noValidate
        // onSubmit={event => {
        //   event.preventDefault();
        //   formikSignUp.handleSubmit();
        // }}
        sx={{
          padding: {xxs: '5px', md: '0 40px 40px'},
          width: {xxs: 'auto', md: '550px'},
        }}
      >
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          marginBottom={'21px'}
        >
          <Box>
            <Typography
              fontStyle={'Nunito Sans'}
              fontSize={'22px'}
              fontWeight={700}
            >
              {isForgotPassword ? 'Forgot your Password?' : 'Welcome Guest'}
            </Typography>
            <Typography
              fontStyle={'Nunito Sans'}
              fontSize={'18px'}
              fontWeight={300}
            >
              {isSignIn
                ? 'Sign in to Hirist'
                : isForgotPassword
                ? 'We’ll help you reset it and get back on track.'
                : 'Register here to access premium technology jobs matching with your profile.'}
            </Typography>
          </Box>
        </Box>
        <Box>
          {renderForm()}
          {!isForgotPassword && (
            <Typography
              mt={{xxs: 2.5, md: 2}}
              textAlign="center"
              color="#7e7e7e"
              fontSize={'16px'}
              fontFamily={'Nunito Sans'}
            >
              {isSignIn ? 'Don’t have an account?' : 'Already have an account?'}{' '}
              <Typography
                component="a"
                sx={{
                  textDecoration: 'none',
                  fontWeight: '700',
                  cursor: 'pointer',
                  color: '#e9630c',
                }}
                onClick={toggleAuthMode}
              >
                {isSignIn ? 'Sign Up' : 'Sign In'}
              </Typography>
            </Typography>
          )}
        </Box>
      </Box>
    </Dialog>
  ) : (
    <MuiDialog open={props?.openDialog} fullScreen data-testid="auth-dialog">
      <Box display="flex" alignItems={'center'}>
        <Grid container direction={{xxs: 'column-reverse', md: 'row'}}>
          <Grid item xxs={12} md={4}>
            <Box>
              <AuthLeft>
                <Image
                  src={HiristBackground}
                  alt="Hirist Background"
                  layout="fill"
                />

                <SiteLogo>
                  <Image
                    src="https://staticlogo.hirist.com/webp/hirist-tech-logo.webp"
                    alt="Logo"
                  />
                </SiteLogo>

                <PeopleSaying>
                  Choose a job you love, and you never have to work a day in
                  your life
                  <Typography component="p" marginTop={'16px'}>
                    - Confucius
                  </Typography>
                </PeopleSaying>

                <CompanyList>
                  <Typography
                    display={'flex'}
                    justifyContent={'center'}
                    marginTop={'16px'}
                    fontSize={'16px'}
                    fontFamily={'Nunito Sans'}
                  >
                    Companies you might love to work with
                  </Typography>
                  <Box
                    display="flex"
                    justifyContent="space-evenly"
                    mt={1}
                    width="100%"
                    data-testid="hirist-companies-list"
                  >
                    {companies.map((company: any, index: any) => (
                      <Box
                        key={index}
                        width="20%"
                        display={
                          index === 3 ? {xxs: 'none', md: 'flex'} : 'flex'
                        }
                        sx={{
                          backgroundImage: `url("${company.imageUrl}")`,
                          backgroundSize: 'contain',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                          aspectRatio: '16/9',
                          cursor: 'pointer',
                        }}
                        data-testid={`hirist-company-item-${index}`}
                        onClick={() => {
                          const {refText} = getRefTagAndOrigin();
                          handleTracking('jsClickLoginLogo', {
                            event_category: 'jsHomePage',
                            Source: isSignIn ? 'login' : 'register',
                            Ref: `${refText}`,
                            CompanyName: company.title,
                            Device:
                              sessionStorage.getItem('device') || 'desktop',
                            Device_Type:
                              sessionStorage.getItem('deviceType') || 'web',
                          });
                          handleUbaTracking(
                            'jsLoginLogoClick',
                            'click',
                            'jsHomePage',
                            isSignIn ? 'signin' : 'signup'
                          );
                          openUrl(`${company.link}`);
                        }}
                      />
                    ))}
                  </Box>
                </CompanyList>
              </AuthLeft>
            </Box>
          </Grid>
          <Grid item xxs={12} md={8}>
            <Box
              display={'flex'}
              justifyContent={isForgotPassword ? 'space-between' : 'flex-end'}
              marginTop={{xxs: '20px', md: '50px'}}
              marginRight={{xxs: '35px', md: '46px'}}
            >
              <Box display={isForgotPassword ? 'flex' : 'none'}>
                <Box
                  onClick={handlebackclick}
                  sx={{
                    cursor: 'pointer',
                    position: 'relative',
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#f2f5fa',
                    borderRadius: '50%',
                    marginLeft: {xxs: '30px', md: '55px'},
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: 'white',
                      boxShadow: '0 6px 14px 0 rgba(0, 0, 0, 0.09)',
                    },
                  }}
                >
                  <Image
                    src={ChevronRight}
                    alt="left-arrow"
                    height={20}
                    width={20}
                    style={{transform: 'rotate(180deg)'}}
                  />
                </Box>
              </Box>
              <Box display={'flex'}>
                <Button
                  onClick={handleDownloadClick}
                  sx={{
                    height: '48px',
                    borderRadius: '24px',
                    border: '1px solid #fceecf',
                    backgroundColor: '#fffbf1',
                    padding: '11px 12px 11px 14px',
                    marginRight: '30px',
                    display: {xxs: 'none', md: 'flex'},
                    alignItems: 'center',
                    '&:hover': {
                      backgroundColor: '#fffbf1',
                    },
                  }}
                >
                  <Image
                    src={PhoneIcon}
                    alt="phoneIcon"
                    height={24}
                    width={24}
                  />
                  <Typography
                    color="#e9630c"
                    marginLeft={1.5}
                    fontSize={'15px'}
                    fontFamily={'Nunito Sans'}
                    fontWeight={400}
                  >
                    Download App
                    <Image
                      src={OrangeRightArrow}
                      alt="orange-arrow"
                      height={13}
                      width={13}
                      style={{
                        marginLeft: '12px',
                        paddingTop: '3px',
                      }}
                    />
                  </Typography>
                </Button>
                <Box
                  onClick={() => {
                    const action = isSignIn
                      ? 'signInCancel'
                      : isForgotPassword
                      ? ''
                      : 'signUpCancel';
                    handleTracking(action, {
                      event_category: 'Offline Landing page',
                      event_label: 'cross=1',
                    });
                    handleUbaTracking(
                      'jsCloseRegisterBoxClick',
                      'click',
                      getUbaPageName()
                    );
                    props.setOpenDialog(false);
                    formik.setErrors({});
                    formikForgot.setErrors({});
                    formikSignUp.setErrors({});
                    setApiError({});
                    isOpenDialog(false);
                  }}
                  sx={{
                    cursor: 'pointer',
                    position: 'relative',
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#f2f5fa',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: 'white',
                      boxShadow: '0 6px 14px 0 rgba(0, 0, 0, 0.09)',
                    },
                  }}
                >
                  <Image
                    src={CrossIcon}
                    alt="cross-icon"
                    height={14}
                    width={14}
                  />
                </Box>
              </Box>
            </Box>
            <Box
              display="flex"
              flexDirection={{xxs: 'column', sm: 'row'}}
              justifyContent="center"
              marginTop={{xxs: '20px', md: '15px'}}
              height={
                isSignIn
                  ? {xxs: '1%'}
                  : isForgotPassword
                  ? {xxs: '6%', md: '1%'}
                  : '1%'
              }
              sx={{
                backgroundColor: 'white',
              }}
            >
              <Box
                width={{xxs: '90%', md: '70%'}}
                px={3}
                marginBottom={'1vh'}
                alignSelf={{xxs: 'center', sm: 'start'}}
              >
                <Typography
                  fontSize={{xxs: '20px', md: '26px'}}
                  fontFamily={'Nunito Sans'}
                  fontWeight={700}
                >
                  {isForgotPassword
                    ? 'Forgot your Password?'
                    : 'Welcome Guest,'}
                </Typography>
                <Typography
                  fontSize={
                    isForgotPassword ? '21px' : {xxs: '32px', md: '46px'}
                  }
                  fontWeight={200}
                  fontFamily={'Nunito Sans'}
                  marginTop={
                    isForgotPassword ? {xxs: '5px', md: '20px'} : '-10px'
                  }
                >
                  {isForgotPassword
                    ? 'We’ll help you reset it and get back on track.'
                    : isSignIn
                    ? 'Sign in to Hirist'
                    : 'Sign up for Hirist'}
                </Typography>
                <Box mt={{xxs: 2.5, md: 5}}>{renderForm()}</Box>
                {!isForgotPassword && (
                  <Typography
                    mt={{xxs: 2.5, md: 2}}
                    textAlign="center"
                    color="#7e7e7e"
                    fontSize={'16px'}
                    fontFamily={'Nunito Sans'}
                  >
                    {isSignIn
                      ? 'Don’t have an account?'
                      : 'Already have an account?'}{' '}
                    <Typography
                      component="a"
                      sx={{
                        textDecoration: 'none',
                        fontWeight: '700',
                        cursor: 'pointer',
                        color: '#e9630c',
                      }}
                      data-testid="auth-toggle-link"
                      onClick={toggleAuthMode}
                    >
                      {isSignIn ? 'Sign Up' : 'Sign In'}
                    </Typography>
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  padding: '10px',
                  marginBottom: '50px',
                  display: {xxs: 'block', sm: 'none'},
                }}
              >
                <DownloadAppOnJobdetail showWidgetMobile={true} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </MuiDialog>
  );
};

export default HiristLoginForm;
